import {Injectable} from '@angular/core';
import {NgbModal} from "@ng-bootstrap/ng-bootstrap";
import {from, Observable} from "rxjs";
import {ExcludedHospitalsModalComponent} from "./excluded-hospitals-modal.component";
import {CrudMode} from "../../../../../app.constants";
import {NchPointCheckHcodeExcludeDto} from "../../../../../../generated-model/model";

@Injectable({providedIn: 'root'})
export class ExcludedHospitalsModalService {

  constructor(private modalService: NgbModal) {
  }

  open(crud: CrudMode, item?: NchPointCheckHcodeExcludeDto): Observable<boolean> {
    this.modalService.dismissAll();
    const modalRef = this.modalService.open(ExcludedHospitalsModalComponent, {size: 'lg'});
    if (crud == "CREATE") {
      modalRef.componentInstance.item = {};
    } else {
      modalRef.componentInstance.item = {hospital: item?.hospital, dateOut: item?.id?.dateOut};
    }
    modalRef.componentInstance.crud = crud;
    return from(modalRef.result)
  }
}
